export {
  INFRA_CAPABILITIES,
  INFRA_COMMAND_CATEGORY,
  INFRA_PACKAGE_METADATA,
  INFRA_PACKAGE_NAME,
  INFRA_PACKAGE_VERSION,
} from '../constants.js';
